module.exports = __webpack_public_path__ + "static/media/5.e117f632.svg";